import { Component, Input, OnInit, Optional, Self, ChangeDetectorRef, Output, EventEmitter, OnChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';

interface DropdownOption {
  id?: number;
  key?: any;
  name?: string;
  value?: string;
}

@Component({
  selector: 'flow-form-select',
  templateUrl: './form-select.component.html',
  styleUrls: ['./form-select.component.scss'],
})
export class FormSelectComponent implements ControlValueAccessor, OnInit, OnChanges {
  @Input() label: string = '';
  @Input() options: DropdownOption[];
  @Input() multiple: boolean = false;
  @Input() isDisabled: boolean = false;
  @Input() required: boolean = false;
  @Input() selectAll: boolean = false;
  @Input() infoTooltip: string = '';
  @Input() placeholder: string = '';
  @Input() panelClass: string = '';
  @Output() selectionChange = new EventEmitter<any>();
  selectAllClicked: boolean = false;
  isAllSelected: boolean = false;
  value: any;

  constructor(@Optional() @Self() protected control: NgControl, private cdr: ChangeDetectorRef) {
    if (this.control) {
      this.control.valueAccessor = this;
    }
  }

  ngOnInit(): void {
    this.cdr.detectChanges();
  }

  ngOnChanges(): void {
    this.cdr.detectChanges();
    this.isAllSelected = this.options?.length > 0 && Array.isArray(this.value) && this.multiple && this.options.every(o => {
      return this.value.includes(o.id || o.key);
    });
  }

  onChange = (value: any) => { };
  onTouched = () => { };

  writeValue(value: any): void {
    this.value = value;

    this.cdr.detectChanges();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
    this.cdr.markForCheck();
  }

  onSelectChange(value: any) {
    this.value = value;
    this.onChange(value);
    this.onTouched();
    this.selectionChange.emit(this.value);
  }
  
  toggleSelectAll(): void {
    const optionIds = this.options.map(o => o.id || o.key);
    const fullSelection = optionIds;

    if (this.isAllSelected) {
      this.value = [];
      this.selectAllClicked = false;
    } else {
      this.selectAllClicked = true;
      this.value = fullSelection;
    }

    this.isAllSelected = !this.isAllSelected;

    this.onSelectChange(this.value);
  }
}
